import { render, staticRenderFns } from "./DeleteCategoryPopup.vue?vue&type=template&id=86947712&"
import script from "./DeleteCategoryPopup.vue?vue&type=script&lang=js&"
export * from "./DeleteCategoryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports